[...document.querySelectorAll('.js-ie-ligature')].map(elem => {
    elem.textContent = elem.textContent.replace('o', 'O');
});
